import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { AttributeLabelPipe } from '@df/ui/common/attribute-label.pipe';
import { DragScrollDirective } from '@df/ui/common/drag-scroll.directive';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ProductStatusDirective } from '../product-status.directive';
import { ProductConfigurableOptionsAbstract } from './product-configurable-options.abstract';

@Component({
    selector: 'product-configurable-options',
    templateUrl: 'product-configurable-options.html',
    styleUrl: './product-configurable-options.scss',
    standalone: true,
    imports: [
        AttributeLabelPipe,
        CommonModule,
        DfImageDirective,
        DragScrollDirective,
        GridModule,
        OptionLabelPipe,
        ProductStatusDirective,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductConfigurableOptionsComponent extends ProductConfigurableOptionsAbstract {}
